import React from "react";
import Loadable from "react-loadable";

// import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const BatchesOverview = Loadable({
  loader: () => import("./views/BatchesOverview/BatchesOverview"),
  loading: Loading,
});

const BrandButtons = Loadable({
  loader: () => import("./views/Buttons/BrandButtons"),
  loading: Loading,
});

const ButtonDropdowns = Loadable({
  loader: () => import("./views/Buttons/ButtonDropdowns"),
  loading: Loading,
});

const ButtonGroups = Loadable({
  loader: () => import("./views/Buttons/ButtonGroups"),
  loading: Loading,
});

const Buttons = Loadable({
  loader: () => import("./views/Buttons/Buttons"),
  loading: Loading,
});

const Charts = Loadable({
  loader: () => import("./views/Charts"),
  loading: Loading,
});

const CoreUIIcons = Loadable({
  loader: () => import("./views/Icons/CoreUIIcons"),
  loading: Loading,
});

const Flags = Loadable({
  loader: () => import("./views/Icons/Flags"),
  loading: Loading,
});

const FontAwesome = Loadable({
  loader: () => import("./views/Icons/FontAwesome"),
  loading: Loading,
});

const SimpleLineIcons = Loadable({
  loader: () => import("./views/Icons/SimpleLineIcons"),
  loading: Loading,
});

const Alerts = Loadable({
  loader: () => import("./views/Notifications/Alerts"),
  loading: Loading,
});

const Badges = Loadable({
  loader: () => import("./views/Notifications/Badges"),
  loading: Loading,
});

const Modals = Loadable({
  loader: () => import("./views/Notifications/Modals"),
  loading: Loading,
});

const Colors = Loadable({
  loader: () => import("./views/Theme/Colors"),
  loading: Loading,
});

const Typography = Loadable({
  loader: () => import("./views/Theme/Typography"),
  loading: Loading,
});

const Widgets = Loadable({
  loader: () => import("./views/Widgets/Widgets"),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import("./views/Users/Users"),
  loading: Loading,
});

const User = Loadable({
  loader: () => import("./views/Users/User"),
  loading: Loading,
});

const Labelling = Loadable({
  loader: () => import("./views/Labelling/Labelling"),
  loading: Loading,
});

const Segmentation = Loadable({
  loader: () => import("./views/Labelling/Segmentation"),
  loading: Loading,
});

const segmentationChecking = Loadable({
  loader: () => import("./views/Labelling/SegmentationChecking"),
  loading: Loading,
});

const controlPanel = Loadable({
  loader: () => import("./views/ControlPanel/ControlPanel"),
  loading: Loading,
});

const trainingSection = Loadable({
  loader: () => import("./views/TrainingSection/TrainingSection"),
  loading: Loading,
});

const trainingSectionFAQ = Loadable({
  loader: () => import("./views/TrainingSection/TrainingSectionFAQ"),
  loading: Loading,
});

const trainingSectionLabelling = Loadable({
  loader: () => import("./views/TrainingSection/TrainingSectionLabelling"),
  loading: Loading,
});

const trainingSectionTutorial = Loadable({
  loader: () => import("./views/TrainingSection/TrainingSectionTutorial"),
  loading: Loading,
});

const labelCheckerOverview = Loadable({
  loader: () => import("./views/LabelChecker/LabelCheckerOverview"),
  loading: Loading,
});

const labelCheckerTrashevents = Loadable({
  loader: () => import("./views/LabelChecker/LabelCheckerTrashevents"),
  loading: Loading,
});

const labelCheckerLabelling = Loadable({
  loader: () => import("./views/LabelChecker/LabelCheckerLabelling"),
  loading: Loading,
});

const agentFeedback = Loadable({
  loader: () => import("./views/AgentFeedback/AgentFeedback"),
  loading: Loading,
});

const performanceReport = Loadable({
  loader: () => import("./views/PerformanceReport/PerformanceReport"),
  loading: Loading,
});

const dataValidity = Loadable({
  loader: () => import("./views/DataValidity/DataValidity"),
  loading: Loading,
});

const outletDataValidity = Loadable({
  loader: () => import("./views/DataValidity/OutletDataValidity"),
  loading: Loading,
});

const imagesDataValidity = Loadable({
  loader: () => import("./views/DataValidity/ImagesDataValidity"),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  {
    path: "/",
    exact: true,
    name: "Home",
    component: BatchesOverview,
  },
  {
    path: "/training",
    exact: true,
    name: "Training Section",
    component: trainingSection,
  },
  {
    path: "/training/faq",
    name: "FAQ",
    component: trainingSectionFAQ,
  },
  {
    path: "/training/labelling",
    name: "Labelling",
    component: trainingSectionLabelling,
  },
  {
    path: "/training/tutorial",
    name: "Tutorial",
    component: trainingSectionTutorial,
  },
  {
    path: "/labelChecker",
    exact: true,
    name: "Label Checker",
    component: labelCheckerOverview,
  },
  {
    path: "/labelChecker/trashevents",
    name: "Trashevents",
    component: labelCheckerTrashevents,
  },
  {
    path: "/labelChecker/labelling",
    name: "Labelling",
    component: labelCheckerLabelling,
  },
  {
    path: "/performanceReport",
    name: "PerformanceReport",
    component: performanceReport,
  },
  {
    path: "/controlPanel",
    name: "Control Panel",
    component: controlPanel,
  },
  {
    path: "/labelling",
    name: "Labelling",
    component: Labelling,
  },
  {
    path: "/segmentation",
    name: "Segmentation",
    component: Segmentation,
  },
  {
    path: "/segmentation_checking",
    name: "Segmentation Checking",
    component: segmentationChecking,
  },
  {
    path: "/feedback",
    name: "Agent Feedback",
    component: agentFeedback,
  },
  {
    path: "/theme",
    exact: true,
    name: "Theme",
    component: Colors,
  },
  {
    path: "/theme/colors",
    name: "Colors",
    component: Colors,
  },
  {
    path: "/theme/typography",
    name: "Typography",
    component: Typography,
  },
  {
    path: "/buttons",
    exact: true,
    name: "Buttons",
    component: Buttons,
  },
  {
    path: "/buttons/buttons",
    name: "Buttons",
    component: Buttons,
  },
  {
    path: "/buttons/button-dropdowns",
    name: "Button Dropdowns",
    component: ButtonDropdowns,
  },
  {
    path: "/buttons/button-groups",
    name: "Button Groups",
    component: ButtonGroups,
  },
  {
    path: "/buttons/brand-buttons",
    name: "Brand Buttons",
    component: BrandButtons,
  },
  {
    path: "/icons",
    exact: true,
    name: "Icons",
    component: CoreUIIcons,
  },
  {
    path: "/icons/coreui-icons",
    name: "CoreUI Icons",
    component: CoreUIIcons,
  },
  {
    path: "/icons/flags",
    name: "Flags",
    component: Flags,
  },
  {
    path: "/icons/font-awesome",
    name: "Font Awesome",
    component: FontAwesome,
  },
  {
    path: "/icons/simple-line-icons",
    name: "Simple Line Icons",
    component: SimpleLineIcons,
  },
  {
    path: "/notifications",
    exact: true,
    name: "Notifications",
    component: Alerts,
  },
  {
    path: "/notifications/alerts",
    name: "Alerts",
    component: Alerts,
  },
  {
    path: "/notifications/badges",
    name: "Badges",
    component: Badges,
  },
  {
    path: "/notifications/modals",
    name: "Modals",
    component: Modals,
  },
  {
    path: "/widgets",
    name: "Widgets",
    component: Widgets,
  },
  {
    path: "/charts",
    name: "Charts",
    component: Charts,
  },
  {
    path: "/users",
    exact: true,
    name: "Users",
    component: Users,
  },
  {
    path: "/users/:id",
    exact: true,
    name: "User Details",
    component: User,
  },
  {
    path: "/dataValidity",
    exact: true,
    name: "Data Validity",
    component: dataValidity,
  },
  {
    path: "/dataValidity/images",
    exact: true,
    name: "Images",
    component: imagesDataValidity,
  },
  {
    path: "/dataValidity/:outlet_id",
    exact: true,
    name: "Outlet",
    component: outletDataValidity,
  },
];

export default routes;
